
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30.002","height":"30.002","rx":"15.001","fill":"#E2E2E2"}}),_c('g',{attrs:{"fill":"#4D4D4D"}},[_c('path',{attrs:{"d":"M15.002 7.85c4.145 0 7.5 3.278 7.5 7.326s-3.355 7.326-7.5 7.326c-4.144 0-7.5-3.278-7.5-7.326.01-4.037 3.367-7.316 7.5-7.326zm0 13.113c3.27 0 5.925-2.593 5.925-5.787s-2.654-5.787-5.925-5.787c-3.27 0-5.924 2.593-5.924 5.787.01 3.194 2.655 5.777 5.925 5.787z"}}),_c('path',{attrs:{"d":"M15.005 13.712a.783.783 0 01-.788-.77V6.397c0-.421.356-.769.788-.769.431 0 .787.348.787.77v6.546c0 .421-.345.77-.787.77z"}})])])
          )
        }
      }
    